import styled from 'styled-components';

export const StyledImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 12px;
`;

export const PrimaryButton = styled.button`
  background: ${({ theme }) => theme.palette.primary.blue500};
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-block;

  &:hover {
    background: ${({ theme }) => theme.palette.primary.blue700};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    width: fit-content;
    min-width: 8rem;
    max-width: 16rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1rem 2rem;
    font-size: 1rem;
  }
`;

export const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  gap: 2rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
    align-items: center;
    padding: 4rem 2rem;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 4rem;
  gap: 1rem;
  order: 2;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    order: 1;
    width: 50%;
  }
`;

export const HeroImageContainer = styled.div`
  order: 1;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    order: 2;
    width: 50%;
  }
`;

export const HeroTitle = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primary.grey600};
  line-height: 1.2;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
    font-size: 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: 3.5rem;
  }
`;

export const HeroDescription = styled.p`
  color: ${({ theme }) => theme.palette.primary.grey600};
  font-size: 1.1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.25rem;
  }
`;

export const BenefitsSectionContainer = styled.section`
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 3rem 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 4rem 2rem;
  }
`;

export const BenefitsTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 70vw;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  gap: 1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0 2rem;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: bold;
  padding: 0 3rem;
  color: ${({ theme }) => theme.palette.primary.blue500};
  margin-bottom: 0.5rem;
  text-align: center;

  
  @media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
    font-size: 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: 3rem;
  }
`;

export const SectionSubtitle = styled.h3`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary.grey600};
  text-align: center;
  padding: 0 2rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
    font-size: 1rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    font-size: 1.5rem;
  }
`;

export const SectionDescription = styled.p`
  color: ${({ theme }) => theme.palette.primary.grey600};
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  max-width: 800px;
  margin: 0 auto 2rem;
  line-height: 1.6;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.1rem;
  }
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  margin: 2rem 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
  }
`;

export const BenefitCard = styled.div`
  background: white;
  padding: 1.25rem;
  border-radius: 8px;
  box-shadow: 10px 10px 40px 0px rgba(184,184,184,0.25);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 10px 10px 40px 0px rgba(184,184,184,0.40);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    padding: 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1.75rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    padding: 2.25rem;
  }
`;

export const BenefitIcon = styled.img`
  width: 50px;
  height: 50px;
  margin-bottom: 0.75rem;
  object-fit: contain;
  transition: transform 0.3s ease;

  ${BenefitCard}:hover & {
    transform: scale(1.05);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    width: 55px;
    height: 55px;
    margin-bottom: 0.85rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 70px;
    height: 70px;
    margin-bottom: 1.1rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 80px;
    height: 80px;
    margin-bottom: 1.25rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktopXl}) {
    width: 90px;
    height: 90px;
    margin-bottom: 1.5rem;
  }
`;

export const CardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: 1.5rem;
  }
`;

export const CardText = styled.p`
  color: ${({ theme }) => theme.palette.primary.grey600};
  font-size: 0.95rem;
  line-height: 1.6;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 0.8rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: 1rem;
  }
`;

export const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-top: 3rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
  }
`;

export const StatItem = styled.div`
  text-align: center;
  transition: all 0.5s ease-out;

  span {
    font-size: 2rem;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.primary.blue500};
    display: block;
    margin-bottom: 0.5rem;
    transition: all 0.5s ease-out;

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
      font-size: 2.5rem;
    }
  }

  p {
    color: ${({ theme }) => theme.palette.primary.grey600};
    font-size: 0.9rem;
    transition: all 0.5s ease-out;

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
      font-size: 1rem;
    }
  }
`;

export const ProcessSection = styled.section`
  background-color: #f8fafc;
  width: 100%;
`;

export const ProcessContainer = styled.div`
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 4rem 2rem;
  }
`;

export const MissionSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem;
  gap: 2rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
    align-items: center;
    padding: 4rem 2rem;
  }
`;

export const MissionImageContainer = styled.div`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 50%;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 50%;
  }
`;

export const MissionHeading = styled.h2`
  font-size: 1.75rem;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primary.blue600};
  line-height: 1.3;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2.25rem;
  }
`;

export const MissionText = styled.p`
  color: ${({ theme }) => theme.palette.primary.grey600};
  font-size: 1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.1rem;
  }
`;

export const FeaturesList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const FeatureItem = styled.li`
  font-size: 1rem;
  color: #333;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &::before {
    content: "✓";
    color: #10b981;
    font-weight: bold;
  }
`;

export const TestimonialsSection = styled.section`
  background-color: #e8f1fc;
  padding: 2rem 1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 4rem 2rem;
  }
`;

export const TestimonialsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const TestimonialCard = styled.div`
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 300px;
  margin: 0 auto;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: calc(50% - 1rem);
  }
`;

export const TestimonialAuthor = styled.p`
  font-weight: bold;
  margin-top: 1rem;
  font-size: 1.1rem;
`;

export const TestimonialsTitle = styled.h2`
  color: ${({ theme }) => theme.palette.primary.blue500};
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
`;

export const TestimonialsSubtitle = styled.p`
  color: ${({ theme }) => theme.palette.primary.grey600};
  font-size: 1rem;
  text-align: center;
  margin-bottom: 2rem;
`;

export const TestimonialEmprise = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  color:  ${({ theme }) => theme.palette.primary.blue500};
`;

export const LogosContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 2rem;
`;

export const PartnerLogo = styled.img`
  height: 30px;
  width: auto;
  object-fit: contain;
  filter: grayscale(100%);
  opacity: 0.7;
  transition: all 0.3s ease;

  &:hover {
    filter: grayscale(0);
    opacity: 1;
  }
`;

export const FAQWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 3rem 2rem;
  }
`;

export const FAQTitle = styled.h2`
  font-size: 1.75rem;
  color: ${({ theme }) => theme.palette.primary.blue500};
  font-weight: 300;
  margin-bottom: 0.5rem;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2rem;
  }
`;

export const FAQSubtitle = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.primary.grey500};
  margin-bottom: 1.5rem;
  text-align: center;
`;

export const FAQContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 1.5rem 0;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primary.blue500};

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    flex-direction: row;
    justify-content: center;
  }

  svg {
    margin-right: 0.5rem;
  }
`;

export const FAQItem = styled.div`
  background: ${({ theme }) => theme.palette.primary.grey50};
  color: ${({ theme }) => theme.palette.primary.grey500};
  margin: 0.75rem 0;
  padding: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  box-shadow: 10px 10px 40px 0px rgba(184,184,184,0.25);

  &.isActive {
    color: ${({ theme }) => theme.palette.primary.blue500};
  }

`;

export const FAQAnswer = styled.div`
  background: #fff;
  padding: 1rem;
  margin-top: 0.5rem;
  white-space: pre-line;
  border-radius: 5px;
  animation: fadeIn 0.3s ease-in-out; 
  line-height: 1.6;
  font-family: inherit; 
  font-weight: 600;

  div {
    &:has(> span.list-item) {
      margin-left: 24px;
    }
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0);}
  }
`;

export const StepsContainer = styled.section`
  background: url('/advertise-img/backgroundnj') no-repeat center;
  background-size: cover;
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 3rem 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 4rem 2rem;
  }
`;

export const StepsContent = styled.div`
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 3rem;
    align-items: flex-start;
  }
`;

export const StepsTextSection = styled.div`
  width: 100%;
  padding: 0 1rem;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex: 1;
    max-width: 400px;
    padding: 0 2rem;
    text-align: left;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 0 4rem;
  }
`;

export const StepsSubtitle = styled.p`
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primary.grey800};
  margin-bottom: 0.5rem;
  font-size: 0.9rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1rem;
  }
`;

export const StepsTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 800;
  margin-bottom: 1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: 2.5rem;
  }
`;

export const StepsDescription = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.palette.primary.grey600};
  margin-bottom: 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
`;

export const StepCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  gap: 1rem;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
    justify-content: space-between;
    padding: 1.5rem;
  }
`;

export const StepInfo = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 1rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 60%;
    text-align: left;
    margin-bottom: 0;
  }
`;

export const StepTitle = styled.h3`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.palette.primary.blue500};
  font-weight: bold;
  margin-bottom: 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.3rem;
  }
`;

export const StepText = styled.p`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.palette.primary.grey600};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 0.9rem;
  }
`;

export const StepIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  img {
    width: 120px;
    height: 60px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    gap: 1rem;

    img {
      width: 150px;
      height: 75px;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    img {
      width: 200px;
      height: 100px;
    }
  }
`;

export const StepNumber = styled.span`
  font-size: 2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.palette.primary.blue500};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 2.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: 3rem;
  }
`;

export const StepDivision = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StepsCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    gap: 1.5rem;
    flex: 1;
  }
`;